import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import { deletePushNotification } from "../../../api/endpoint";
import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import Loader from "../../../components/loader";

const DeleteModal = ({ isDeleteOpen, closeDeleteModal, id, fetchData }) => {
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  const deleteNotification = async () => {
    try {
      setLoading(false);
      const response = await axios.delete(deletePushNotification, {
        params: { id: id },
        headers: { Authorization: `Bearer ${auth}` },
      });
      toast.success(response?.data?.message)
      closeDeleteModal()
      fetchData()
    } catch (error) {
      toast.error("Error deleting notification");
      console.error("Error deleting notification", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <Loader/>}
      <Modal show={isDeleteOpen} onHide={closeDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Push Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this Push Notification?
        </Modal.Body>
        <Modal.Footer>
          <Button
            text="Delete Push Notification"
            callBack={deleteNotification}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteModal;
